<template>
    <img :src="pictureUrl" class="tw-w-full tw-h-full tw-object-fit">
</template>

<script>
    export default {
        props: {
            pictureUrl: {
                type: String,
                required: true,
            }
        }
    }
</script>